import * as React from 'react'

const styles: React.CSSProperties = {
  position: 'absolute',
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  border: 0,
}

interface VisuallyHiddenProps {
  as?: keyof JSX.IntrinsicElements
  children: React.ReactNode
  id?: string
}

export const VisuallyHidden = ({ as, children, id }: VisuallyHiddenProps) => {
  const Tag = (as || 'span') as keyof JSX.IntrinsicElements
  return React.createElement(Tag, { style: styles, id }, children)
}
